import React from "react";
import { Account } from "@common/types/domains/accounting/account";
import { View } from "@common/types/views/views";
import { AllocationTable } from "./AllocationTable";
import { RemainingLineSetters } from "./useRemainingLineSetters";
import { MatchableItem, MatchItemType } from "../types";
import styles from "../EditAllocationDrawer.module.scss";

interface AddLineAction {
    key: string;
    label: string;
    onClick: () => void;
}

interface Props {
    readonly items: MatchableItem[];
    readonly lineHandlers: RemainingLineSetters & {
        removeLine: (id: string) => void;
    };
    readonly addLineActions: AddLineAction[];
    readonly matchItemType: MatchItemType | null;
    readonly view: View;
    readonly onViewChange: (view: View) => void;
    readonly accounts?: Account[];
    readonly entityId?: number;
    readonly accountsByEntityId?: Record<number, Account[]>;
    readonly showAccountNumbers: boolean;
    readonly amountToBeAllocated: number;
}

export const RemainingAllocationSection: React.FC<Props> = ({
    items,
    lineHandlers,
    addLineActions,
    matchItemType,
    view,
    onViewChange,
    accounts,
    entityId,
    accountsByEntityId,
    showAccountNumbers,
    amountToBeAllocated,
}) => (
    <div>
        <div className={styles.sectionHeader}>Resolve difference</div>
        <AllocationTable
            data={items}
            section="remaining"
            matchItemType={matchItemType}
            view={view}
            onViewChange={onViewChange}
            accounts={accounts}
            entityId={entityId}
            accountsByEntityId={accountsByEntityId}
            showAccountNumbers={showAccountNumbers}
            amountToBeAllocated={amountToBeAllocated}
            onRemainingAccountChange={lineHandlers.updateAccount}
            onRemainingCashAccountChange={lineHandlers.updateCashAccount}
            onRemainingCategoryChange={lineHandlers.updateCategory}
            onRemainingAmountChange={lineHandlers.updateAmount}
            onRemainingDescriptionChange={lineHandlers.updateDescription}
            onRemoveRow={lineHandlers.removeLine}
        />
        {addLineActions.map((action) => (
            <button
                key={action.key}
                type="button"
                className={styles.addLineRow}
                onClick={action.onClick}
            >
                {action.label}
            </button>
        ))}
    </div>
);
